var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRowsLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 17,
    viewBox: "0 0 201 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "righe",
    transform: "translate(-582.5 -1211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M172.646,429.531h-80a.5.5,0,0,1,0-1h80a.5.5,0,0,1,0,1Z",
    transform: "translate(490.354 798.469)",
    fill: "#c2a260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M212.646,429.531h-120a.5.5,0,0,1,0-1h120a.5.5,0,0,1,0,1Z",
    transform: "translate(490.354 790.469)",
    fill: "#c2a260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M292.646,429.531h-200a.5.5,0,0,1,0-1h200a.5.5,0,0,1,0,1Z",
    transform: "translate(490.354 782.469)",
    fill: "#c2a260"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowsLeft);
export default __webpack_public_path__ + "static/media/rows-left.1323cdf9a6624061cc0624fa39abe86f.svg";
export { ForwardRef as ReactComponent };